export const CURRENT_GAME = "2026Oscars";
export const CURRENT_TITLE = "The 2026 Academy Awards";
export const PROD_DATABASE = {
  apiKey: "AIzaSyDGkgi0mqNXArVXeP2X9kF421JGP9Yi4bY",
  authDomain: "awards-season.firebaseapp.com",
  databaseURL: "https://awards-season.firebaseio.com",
  projectId: "awards-season",
  storageBucket: "awards-season.appspot.com",
  messagingSenderId: "829477688648",
  appId: "1:829477688648:web:1f835b494a2085fe6a8f7d",
};

export const STAGING_DATABASE = {
  apiKey: "AIzaSyDrc0t5YtIKDIyqr5pzXSkVINfcahiE8EI",
  authDomain: "awards-season-staging.firebaseapp.com",
  databaseURL: "https://awards-season-staging.firebaseio.com",
  projectId: "awards-season-staging",
  storageBucket: "awards-season-staging.appspot.com",
  messagingSenderId: "431816305555",
  appId: "1:431816305555:web:edbf9b0df745345f181666",
};
